import React, { useState, useEffect, useContext } from 'react';
import { isEmpty, get, forIn } from 'lodash';
import WidgetSectionTitle from '../../../widgets/CustomWidgetSectionTitle';
import useAPI from 'hooks/useApi';
import AppContext from 'context/Context';
import waterIcon from 'assets/img/icons/water.svg';
import locationIcon from 'assets/img/icons/land.svg';
import soilIcon from 'assets/img/icons/soil_param.svg';
import Enviroment from 'assets/img/icons/Enviroment.svg';
import {
  getComparisonLocations,
  getTerrestrialComparison
} from 'api/endpoints/TerrestrialServices';
import { getEnvironmentologyComparison } from 'api/endpoints/EnvironmentalServices';
import { getHydrologicalComparison } from 'api/endpoints/HydrologicalServices';
import { getSoilComparison } from 'api/endpoints/PedologicalServices';
import { useOutletContext, useParams } from 'react-router-dom';
import ErrorNotFound from 'components/errors/ErrorNotFound';
import { getProjectDetails } from 'api/endpoints/ManagementServices';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import CardSkeleton from 'components/common/skeleton/CardSkeleton';
import CustomSelect from 'components/common/CustomSelect';
import useApi from 'hooks/useApi';
import MultiParamsBarChart from './MultiParamsBarChart';
import MultiParamSeasonalChart from './MultiParamSeasonalChart';
import CustomSpinner from 'components/common/CustomSpinner';
import { jwtDecode } from 'jwt-decode';
import ComparisonChart from './ComparisonChart';
import { getTenantFromToken } from 'utils/routeUtils';

const Comparison = () => {
  const { setConfig } = useContext(AppContext);
  const {
    config: { isDark }
  } = useContext(AppContext);

  const tenant = getTenantFromToken();

  const { request_id } = useParams();
  const { setApisLoading } = useOutletContext();

  const { cluster } = useParams();
  const [showErrorPage, setshowErrorPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSelected, setIsSelected] = useState(false);

  const [selectedBaseLine, setSelectedBaseLine] = useState(null);
  const [selectedBlock, setSelectedBlock] = useState([]);

  const [locationData, setLocationData] = useState([]);
  const [locationLoading, setLocationLoading] = useState(false);
  const [monitoringLocationData, setComparisonLocationData] = useState([]);
  const [isLimitReached, setIsLimitReached] = useState(false);

  const getProjectDetailsAPI = useAPI(getProjectDetails);
  const getEnvironmentologyComparisonAPI = useAPI(
    getEnvironmentologyComparison
  );
  const getHydrologicalComparisonAPI = useAPI(getHydrologicalComparison);
  const getTerrestrialComparisonAPI = useAPI(getTerrestrialComparison);
  const getSoilComparisonAPI = useAPI(getSoilComparison);

  const [ProjectDetails, setProjectDetails] = useState({});
  const [coordinates, setCoordinates] = useState([]);
  const [soilComparisonData, setSoilComparisonData] = useState([]);
  const [overAllComparisonData, setOverAllComparisonData] = useState({});
  const [environmentologyComparisonData, setEnvironmentologyComparisonData] =
    useState({});
  const [hydrologicalComparisonData, setHydrologicalComparisonData] = useState(
    {}
  );
  const [terrestrialComparisonData, setTerrestrialComparisonData] = useState(
    {}
  );

  const getComparisonLocationAPI = useApi(getComparisonLocations);

  const apiHooks = [
    getTerrestrialComparisonAPI,
    getEnvironmentologyComparisonAPI,
    getHydrologicalComparisonAPI,
    getSoilComparisonAPI
  ];

  const performComparisonLocationAPICall = async () => {
    setLocationLoading(true);
    await getComparisonLocationAPI.request(tenant);
    setLocationLoading(false);
  };

  useEffect(() => {
    performComparisonLocationAPICall();
  }, []);

  const performSequentialAPICalls = async formData => {
    setIsSelected(true);
    setLoading(true);
    for (let i = 0; i < apiHooks.length; i++) {
      await apiHooks[i].request(formData);
    }
    setLoading(false);
  };

  const resetApiStates = () => {
    for (let i = 0; i < apiHooks.length; i++) {
      apiHooks[i].setLoading(true);
    }
  };

  useEffect(() => {
    if (!isEmpty(getComparisonLocationAPI.data)) {
      const responseData = get(getComparisonLocationAPI.data, 'results', {});
      const filterOptions = [];
      forIn(responseData, (value, key) => {
        filterOptions.push({ key, value });
      });
      if (!isEmpty(filterOptions)) {
        // setFirstMonitoringCluster(filterOptions[0]?.key);
        setComparisonLocationData(filterOptions);
        setConfig('cluster', filterOptions[0]?.key);
        setLocationData(filterOptions);
      }
    }
  }, [getComparisonLocationAPI.data]);

  useEffect(() => {
    if (
      !isEmpty(getTerrestrialComparisonAPI.error) ||
      !isEmpty(getHydrologicalComparisonAPI.error) ||
      !isEmpty(getEnvironmentologyComparisonAPI.error) ||
      !isEmpty(getProjectDetailsAPI.error) ||
      !isEmpty(getSoilComparisonAPI.error)
    ) {
      setshowErrorPage(true);
    }
  }, [
    getTerrestrialComparisonAPI.error,
    getHydrologicalComparisonAPI.error,
    getEnvironmentologyComparisonAPI.error,
    getProjectDetailsAPI.error,
    getSoilComparisonAPI.error
  ]);

  useEffect(() => {
    const data = get(getProjectDetailsAPI.data, 'results', {});
    setProjectDetails(data);
  }, [getProjectDetailsAPI.data]);

  useEffect(() => {
    if (ProjectDetails && ProjectDetails?.coordinates) {
      const coordinatesArray = ProjectDetails?.coordinates
        .match(/-?\d+\.\d+/g)
        .map(Number);
      const formattedCoordinates = [];
      for (let i = 0; i < coordinatesArray.length; i += 2) {
        formattedCoordinates.push([
          coordinatesArray[i + 1],
          coordinatesArray[i]
        ]);
      }
      setCoordinates(formattedCoordinates);
    }
  }, [ProjectDetails]);

  useEffect(() => {
    if (!isEmpty(getSoilComparisonAPI.data)) {
      setSoilComparisonData(get(getSoilComparisonAPI.data, 'results', {}));
    }
  }, [getSoilComparisonAPI.data]);
  useEffect(() => {
    if (!isEmpty(getTerrestrialComparisonAPI.data)) {
      setTerrestrialComparisonData(
        get(getTerrestrialComparisonAPI.data, 'results', {})
      );
    }
  }, [getTerrestrialComparisonAPI.data]);

  useEffect(() => {
    if (!isEmpty(getEnvironmentologyComparisonAPI.data)) {
      setEnvironmentologyComparisonData(
        get(getEnvironmentologyComparisonAPI.data, 'results', {})
      );
    }
  }, [getEnvironmentologyComparisonAPI.data]);

  useEffect(() => {
    if (!isEmpty(getHydrologicalComparisonAPI.data)) {
      setHydrologicalComparisonData(
        get(getHydrologicalComparisonAPI.data, 'results', {})
      );
    }
  }, [getHydrologicalComparisonAPI.data]);

  const environmentologyObservation = get(
    environmentologyComparisonData,
    'environmentology_observation'
  );

  const hydrologicalObservation = get(
    hydrologicalComparisonData,
    'hydrological_observation'
  );

  const pedologicalObservation = get(
    soilComparisonData,
    'pedological_observation'
  );

  const terrestrialObservation = get(
    terrestrialComparisonData,
    'terrestrial_observation'
  );

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLimitReached(false);
    if (!isEmpty(selectedBaseLine) && isEmpty(selectedBlock)) {
      return;
    }

    const formData = {
      base_project_id: selectedBaseLine?.value,
      sub_project_ids: selectedBlock?.map(i => i.value)
    };
    // Check if formData has values before proceeding
    if (isEmpty(formData)) {
      return;
    }
    // console.log(formData, 'formData');
    try {
      // Make the API request with the formData
      setEnvironmentologyComparisonData({});
      setHydrologicalComparisonData({});
      setTerrestrialComparisonData({});
      const response = await performSequentialAPICalls(formData);

      if (response.ok) {
        // console.log('API Response:', response.data);
      } else {
        console.error('API Error:', response.error);
      }
    } catch (error) {
      console.error('API Request Error:', error);
    }
  };

  const handleSelectionChange = value => {
    setSelectedBlock(value);
    setIsLimitReached(value.length >= 3);
  };

  // Function to display a message when the limit is reached

  // console.log(terrestrialObservation, 'terrestrial////');
  // console.log(pedologicalObservation, '////');
  // console.log(hydrologicalObservation, '////');
  // console.log(environmentologyObservation, '////');

  return (
    <>
      {/* {loading ? (

        <ErrorNotFound />

      ) : ( */}
      <>
        {/* <Container> */}
        <Row className="mb-3">
          <Col xs={12}>
            <Form className="mt-1" onSubmit={handleSubmit}>
              <Row className="g-3 g-lg-4">
                <Col lg={3}>
                  <CustomSelect
                    isClearable={true}
                    placeholder="Select BaseLine"
                    classNamePrefix="react-select"
                    isDisabled={loading}
                    value={selectedBaseLine}
                    options={locationData?.map(option => ({
                      value: option.key,
                      label: option.value
                    }))}
                    onChange={value => {
                      setSelectedBaseLine(value);
                      setSelectedBlock([]);
                    }}
                  />
                </Col>
                <Col lg={3}>
                  <CustomSelect
                    isClearable={true}
                    placeholder="Select Blocks"
                    classNamePrefix="react-select"
                    isDisabled={isEmpty(selectedBaseLine) || loading}
                    value={selectedBlock}
                    options={locationData
                      ?.filter(option => option.key !== selectedBaseLine?.value)
                      ?.map(option => ({
                        value: option.key,
                        label: option.value
                      }))}
                    isMulti
                    isOptionDisabled={() => selectedBlock.length >= 3}
                    onChange={handleSelectionChange}
                  />
                  {isLimitReached && (
                    <span style={{ color: 'red', fontSize: '10px' }}>
                      Maximum selection limit reached ({3} selections allowed).
                    </span>
                  )}
                </Col>
                <Col className="d-flex justify-content-end align-items-start">
                  <Button variant="primary" type="submit">
                    Search
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        {!isSelected && (
          <Container
            className="d-flex align-items-center justify-content-center"
            style={{ height: '200px' }}
          >
            <p
              style={{
                color: 'green',
                fontSize: '20px',
                textAlign: 'center'
              }}
            >
              Please select two locations and click ‘Search’
            </p>
          </Container>
        )}
        {isSelected && (
          <>
            {!isEmpty(terrestrialObservation) && (
              <WidgetSectionTitle
                icon={locationIcon}
                title="Vegetation Parameters"
                transform="shrink-4"
                className="mb-4 mt-4 align-items-center"
              />
            )}
            <Row className="g-3 mb-3">
              <ComparisonChart
                observation={terrestrialObservation}
                loading={getTerrestrialComparisonAPI.loading}
              />
              {/* )} */}
            </Row>
            {!isEmpty(environmentologyObservation) && (
              <WidgetSectionTitle
                icon={Enviroment}
                title="Air Quality"
                transform="shrink-4"
                className="mb-4 mt-4 align-items-center"
              />
            )}
            <Row className="g-3 mb-3">
              {/* {!isEmpty(environmentologyObservation) && ( */}
              <ComparisonChart
                observation={environmentologyObservation}
                loading={getEnvironmentologyComparisonAPI.loading}
              />
              {/* )} */}
            </Row>
            <Row className="g-3 mb-3"></Row>
            {!isEmpty(hydrologicalObservation) && (
              <WidgetSectionTitle
                icon={waterIcon}
                title="Water Availability"
                transform="shrink-4"
                className="mb-4 mt-4 align-items-center"
              />
            )}
            <Row className="g-3 mb-3">
              {/* {!isEmpty(hydrologicalObservation) && ( */}
              <ComparisonChart
                observation={hydrologicalObservation}
                loading={getHydrologicalComparisonAPI.loading}
              />
              {/* )} */}
            </Row>
            {!isEmpty(pedologicalObservation) && (
              <WidgetSectionTitle
                icon={soilIcon}
                title="Soil Quality"
                transform="shrink-4"
                className="mb-4 mt-4 align-items-center"
              />
            )}
            <Row className="g-3 mb-3">
              {/* {!isEmpty(pedologicalObservation) && ( */}
              <ComparisonChart
                observation={pedologicalObservation}
                loading={getSoilComparisonAPI.loading}
              />
              {/* // )} */}
            </Row>
          </>
        )}

        {/* </Container> */}
      </>
      {/* // )} */}
    </>
  );
};

export default Comparison;
